import update from 'immutability-helper';
import {
    USER_LOGGED_IN,
    USER_LOGGED_OUT,
    JWT_ISSUED,
    PROFILE_UPDATED_BY_FORM
} from '../actions/types'

export default function auth(state = {authenticated: false, jwt: null, user: null, issued: null}, action = {}) {
    switch(action.type) {
        case USER_LOGGED_IN:
            return update(state, {
                authenticated: {$set: true},
                jwt: {$set: action.payload.jwt},
                user: {$set: action.payload.user},
                issued: {$set: action.payload.issued}
            });

        case JWT_ISSUED:
            return update(state, {
                issued: {$set: action.payload}
            });

        case USER_LOGGED_OUT:
            return update(state, {
                authenticated: {$set: false},
                jwt: {$set: null},
                user: {$set: null},
                issued: {$set: null}
            });

        case PROFILE_UPDATED_BY_FORM:
            const {field, value} = action.payload;
            return update(state, {
                user: {
                    [field]: {$set: value}
                }
            })

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/auth.js